export const I18N = {
    de: {
        formFieldComponent: {
            globalMessages: {
                requiredFieldsHint: 'Pflichtfelder sind mit * gekennzeichnet.',
                required: 'Eine Eingabe wird benötigt.',
                number: 'Geben Sie bitte eine gültige Zahl ein.',
                nothingSelected: 'Bitte wählen Sie ein Option aus.',
                maxlength: 'Es handelt sich um eine ungültige Länge. Die maximale Länge ist {requiredLength}.',
                dateParseError: 'Geben Sie bitte das Datum im folgendem Format ein: "TT.MM.JJJJ"',
                max: 'Es handelt sich um eine ungültige Größe. Die maximale Größe ist {max}.',
                min: 'Es handelt sich um eine ungültige Größe. Die minimale Größe ist {min}.'
            }
        },
        formInputComponent: {
            placeholder: 'Bitte wählen'
        },
        multipleInputComponent: {
            noResult: 'Kein Ergebnis.',
            notEnoughChars: 'Bitte geben Sie mindestens {minChars} Zeichen ein.'
        },
    },
    en: {
        formFieldComponent: {
            globalMessages: {
                requiredFieldsHint: 'Mandatory fields are marked with *.',
                required: 'An Input is required',
                number: 'Please enter a valid number.',
                nothingSelected: 'Please select an option.',
                maxlength: 'This is an invalid length. The maximum length is {requiredLength}.',
                dateParseError: 'Please enter a date in the format: "DD/MM/YYYY"',
                max: 'This is an invalid size. The maximum size is {max}.',
                min: 'This is an invalid size. The minimum size is {min}.'
            }
        },
        formInputComponent: {
            placeholder: 'Please select'
        },
        multipleInputComponent: {
            noResult: 'No result.',
            notEnoughChars: 'Please enter more characters to get a list of suggestions.'
        },
    }
};
